import { FilterType } from "./FilterType";
import { ResCallback } from "./ResCallback";

export interface IFilterTypeValue {
  value: FilterType;
  title: string;
}

export const stringFilterOptions = (res: ResCallback): IFilterTypeValue[] => {
  return [
    {
      value: "Contains",
      title: res("label_FilterValue_Contains"),
    },
    {
      value: "StartsWith",
      title: res("label_FilterValue_StartsWith"),
    },
  ];
};
